export default __webpack_public_path__ + "static/media/Amarres-geodésico.8a14f941.png";